import { SpaTreatmentsCategoryVersion } from '@features/spa/pages/SpaTreatmentsCategory/SpaTreatmentsCategoryVersion';

import { fetchSpaCategories } from '@store/entity/actions';
import * as entityActions from '@store/entity/actions';
import { fetchSpaSettings } from '@store/setting/actions';
import * as journeyActions from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { entitySelectors } from '@store/entity/selectors';

import { QueryClient } from '@tanstack/react-query';
import {
  getSpaTreatmentsPagePrefetch,
  getAvailableSpaTreatmentsPrefetch,
} from '@features/spa/hooks';

import { UNCATEGORIZED_VALUE } from '@features/spa/utils/buildCategoryOptions';

const SpaTreatmentsCategory = ({ property, category, language }) => (
  <div>
    <SpaTreatmentsCategoryVersion property={property} language={language} category={category} />
  </div>
);

SpaTreatmentsCategory.getInitialProps = async ({ store, property, language, query }) => {
  const isUncategorized = query.id === UNCATEGORIZED_VALUE;

  if (property) {
    const { spaDate } = yourJourneySelectors.getParsedJourneyParams(store.getState());
    const client = new QueryClient();
    await Promise.all([
      ...(isUncategorized
        ? []
        : [entityActions.fetchCategory(property.id, query.id, language)(store.dispatch)]),
      store.dispatch(journeyActions.changeJourneyParam('spaDate', spaDate)),
      getAvailableSpaTreatmentsPrefetch(
        client,
        property.id,
        language,
        null,
        isUncategorized ? null : Number(query.id)
      ),
      fetchSpaSettings(property.id)(store.dispatch),
      getSpaTreatmentsPagePrefetch(client, property.id, language),
      fetchSpaCategories(property.id, language)(store.dispatch),
    ]);
  }

  const category = isUncategorized
    ? { id: UNCATEGORIZED_VALUE, name: '', description: null, image: null }
    : entitySelectors.getCategory(store.getState(), query.id);

  return {
    property,
    category,
    language,
  };
};

export default SpaTreatmentsCategory;
